import { Button, Loading } from '@brighterion/br-ui';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { handleOnClickEvent, handleKeyEvent } from 'Utils';
import useSingleReportCSV from 'Hooks/query-hooks/reports/useSingleReportCSV';
import { trackEvent, EventTypes, EventNames } from '@brighterion/insights';
import { ExportCSVErrorModal } from './ExportCSVErrorModal';

type Props = {
    recordId: string;
    reportProperties: ProcessedNewMerchantReportFormValues;
    reportType: ReportType;
};

const ExportCSV = ({ recordId, reportProperties, reportType }: Props) => {
    const { t } = useTranslation();
    const [errorModalOpen, setErrorModalOpen] = useState(false);
    const newReport = useSingleReportCSV({ reportId: parseInt(recordId, 10) });

    const handleTrackEvent = () => {
        let clickIdentifier = '';
        let text = '';
        if (reportType === 'merchantsummary') {
            clickIdentifier = 'Merchant Summary Report - Export CSV';
            text = 'Export Merchant Summary Report';
        } else if (reportType === 'performance') {
            clickIdentifier = 'Rule Performance Report - Export CSV';
            text = 'Export Rule Performance Report';
        }

        if (!clickIdentifier || !text) {
            return;
        }
        trackEvent({
            eventType: EventTypes.track,
            eventName: EventNames.click,
            payload: {
                clickIdentifier,
                text
            }
        });
    };

    const exportCsvAction = () => {
        newReport.remove();
        newReport.refetch();
        handleTrackEvent();
    };

    return (
        <>
            {newReport.isInitialLoading ? (
                <Loading size='sm' fillName='orange' />
            ) : (
                <Button
                    variant='secondary'
                    size='small'
                    data-testid='upload-btn'
                    onClick={handleOnClickEvent(exportCsvAction)}
                    onKeyDown={handleKeyEvent(exportCsvAction)}
                    disabled={!reportProperties}
                >
                    {t('Export CSV')}
                </Button>
            )}
            <ExportCSVErrorModal
                isOpen={errorModalOpen}
                closeModal={() => {
                    setErrorModalOpen(false);
                }}
                createReport={() => newReport.refetch()}
            />
        </>
    );
};

export default ExportCSV;
